// React
import { ReactNode } from "react"

// UI
import { cn } from "@/lib/utils"
import { HeaderNoAuth } from "@/components/navigation/HeaderNoAuth"
import { FooterNoAuth } from "@/components/navigation/FooterNoAuth"

// Translations
import { useTrans } from "@/lib/i18n"

/**
 * NoAuthLayout
 * Renders the children without any authentication or authorization checks
 * Displays the branded header
 *
 * @param param0
 * @returns
 */
export function NoAuthLayout({ children }: { children: ReactNode }) {
	const t = useTrans()
	return (
		<>
			{/* Skip link — first focusable element for keyboard users */}
			<a
				href="#main-content"
				className={cn(
					// focus:not-sr-only resets clip/width/height/margin/overflow for visibility;
					// focus:absolute deliberately overrides its position:static for skip-link placement.
					// oxlint-disable-next-line tailwindcss/no-conflicting-classes
					"sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50",
					"focus:rounded focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-medium",
					"focus:outline-primary-500 focus:text-gray-900 focus:shadow-lg focus:outline-2",
				)}
			>
				{t("common:navigation.skip_to_main")}
			</a>
			<HeaderNoAuth />

			<main
				id="main-content"
				className="flex items-center justify-center bg-[#f8f8f8] px-4"
			>
				<div className="w-full max-w-7xl">{children}</div>
			</main>

			<FooterNoAuth />
		</>
	)
}
